export default "__VITE_ASSET__6d1cfee3__"